export var ExternalUsersSsoEnforcement;
(function (ExternalUsersSsoEnforcement) {
    /**
     * The value is disabled to avoid another DB migration and mapping
     * since we've already mapped previous ssoEnforcement to this value and didn't
     * consider that it should be not_required instead of disabled
     */
    ExternalUsersSsoEnforcement["NOT_REQUIRED"] = "disabled";
    ExternalUsersSsoEnforcement["REQUIRED"] = "required";
})(ExternalUsersSsoEnforcement || (ExternalUsersSsoEnforcement = {}));
